
// debounce from underscore.js
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
     
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// use x and y mousewheel event data to navigate flickity
function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
  // do not trigger a slide change if another is being animated
  if (!slick_is_animating) {
    // pick the larger of the two delta magnitudes (x or y) to determine nav direction
    var direction =
      Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
console.log(direction);
    console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

    if (direction > 0) {
      // next slide
      slick_instance.slick("slickNext");
      
        $('video').each(function(){
          $(this).get(0).pause();
             });    
      
            $('.MainButtonWrapper').css('opacity','1');
           $('.MainHeaderinfo').css('opacity', '1');
           $(".VideoSettinginfo").removeClass("removeoverlay");
          $(".Simianleftcont").removeClass('simiancontent');
      $(".Simianleftcont").css('display','none');
      
      
  
    } else if(direction < 0) {
      // prev slide
      slick_instance.slick("slickPrev");
       $('video').each(function(){
          $(this).get(0).pause();
          });
            $('.MainButtonWrapper').css('opacity','1');
           $('.MainHeaderinfo').css('opacity', '1');
      $(".VideoSettinginfo").removeClass("removeoverlay");
       $(".Simianleftcont").removeClass('simiancontent');
      $(".Simianleftcont").css('display','none');      
     $('body').addClass('videoScrolled');
      $('.MainWorkGrid_Section').css("display", "none");
      $('.MainWorkGrid_Section').addClass('Custom_hidden');
            
    }
  
}
}



// debounce the wheel event handling since trackpads can have a lot of inertia
var slick_handle_wheel_event_debounced = debounce( 
  slick_handle_wheel_event
  , 100, true
  
);



const slick_2 = $(".BeaconImageSubmain");
slick_2.slick({
   lazyLoad: 'ondemand',
   infinite: false,
  adaptiveHeight: true,
  dots: true,
  touchMove: true,
  vertical: true, 
  verticalSwiping: true
 
});


var slick_2_is_animating = false;
var currentSlideIndex = 0; // Initialize the current slide index
 const lastSliderIndex = 6; 
$(document).ready(function() {
setTimeout(function() {
    var getColor = $('.BeaconImageContents[data-slick-index="0"]').attr('getcolor');   
     $('.MainNavigation .Mainnavlist li a').css('color', getColor);
   $('.LogoDetails a p svg path').css('fill',getColor);
   $('.BeaconHeaderLogo a span svg path').css('fill',getColor);
},100);
});


$('.MainHeaderinfo').addClass('slideColor-0');
var last_slide = false;
var isLastSlide = false;
 setTimeout(function() {$('.Our_WorkPage[data-attr="all"]').trigger('click');},100);
slick_2.on("afterChange", function(index, slick, currentSlide) {
  isLastSlide = currentSlide === slick.slideCount - 1;
  setTimeout(function() {
$('.Our_WorkPage[data-attr="all"]').trigger('click');
  },100);
    console.log("Slide after change " + index);
  
    var totalSlides = slick.slideCount;
   var getColorValue = $('.slick-slide[data-slick-index="' + currentSlide + '"].BeaconImageContents').attr('getcolor');
    var appendcolor = $('.MainNavigation .Mainnavlist li a').css('color',getColorValue);
    $('.LogoDetails a p svg path').css('fill',getColorValue);
   
    var dynamicClass = 'slideColor-' + currentSlide;
    $('.MainHeaderinfo').addClass(dynamicClass);   
    if (currentSlideIndex !== currentSlide) {     
        var previousClass = 'slideColor-' + currentSlideIndex;
        $('.MainHeaderinfo').removeClass(previousClass);
    }

  if ($('body').hasClass('template-index')) {

if (window.innerWidth <= 1024) {
    if (currentSlide === slick.slideCount - 1) {
        $(document).on('touchmove', function () {
            setTimeout(function () {
                console.log("dragged");
                $('body').removeClass('videoScrolled');
  $('.MainWorkGrid_Section').css({
    'opacity': '1',
    'display': 'block'
});
                if (!$('.Our_WorkPage[data-attr="all"]').hasClass("all_active")) {
                    $('.Our_WorkPage[data-attr="all"]').addClass('all_active');
                    $('.Our_WorkPage[data-attr="all"]').trigger('click');
                }

                $(document).off('touchmove');
            }, 500);
        });
    } else {
        // Use a single setTimeout and check if the class is already present before removing
        setTimeout(function () {
            if (!$('body').hasClass('videoScrolled')) {
                $('body').addClass('videoScrolled ');
                $('.MainWorkGrid_Section').css({
    'opacity': '0',
    'display': 'none'
});
            }
        }, 0.1);
    }
}
 
      
 

      
      else {
    var lastSlideAlertShown = false; 
$(window).on('wheel', function (e) {
   console.log(e);
      

    if (currentSlide === totalSlides - 1 && !lastSlideAlertShown) {
       // $('body').css('overflow','auto');
        // $('html,body').animate({
        //     scrollTop: $(".MainWorkGrid_Section").offset().top
        // }, 'slow');
    
      setTimeout(function() {
        
        if(e.originalEvent.deltaY > 0){
         
      $('body').removeClass('videoScrolled'); 
          $('.MainWorkGrid_Section').css("display", "block");
        if ($('.Our_WorkPage[data-attr="all"]').hasClass("all_active")) {        
        }else{          
          $('.Our_WorkPage[data-attr="all"]').addClass('all_active');
           $('.Our_WorkPage[data-attr="all"]').trigger('click');
        }
        }
      },100)
      $('.MainWorkGrid_Section').removeClass('Custom_hidden');
           
      lastSlideAlertShown = true; 
    }

});

}
    
  }
    currentSlideIndex = currentSlide; 

    slick_2_is_animating = false;
    $('video').each(function() {
        $(this).get(0).pause();
    });
     $('.MainButtonWrapper').css('opacity', '1');
       $('.MainHeaderinfo').css('opacity', '1');
    $(".VideoSettinginfo").removeClass("removeoverlay");
});



slick_2.on("beforeChange", function(index, event, slick, currentSlide, nextSlide) {
  

    console.log("Slide before change " + index);
    var dynamicClass = 'slideColor-' + nextSlide;

    // Remove the class associated with the current slide
    var previousClass = 'slideColor-' + currentSlide;
    $('.MainHeaderinfo').removeClass(previousClass).addClass(dynamicClass);

    slick_2_is_animating = true;
    $('video').each(function() {
        $(this).get(0).pause();
    });
    $('.MainButtonWrapper').css('opacity', '1');
  $(".MainButtonWrapper").addClass('addedopcity');
       $('.MainHeaderinfo').css('opacity', '1');
    $(".VideoSettinginfo").removeClass("removeoverlay");

  
});
 //   $('.showMobileOnly').on('afterChange', function(event, slick, currentSlide){

 // if (currentSlide === slick.slideCount - 1 ) {
         
 //                      $(document).on('touchmove', function(){
 //                         setTimeout(function() {
 //            console.log("dragged");
 //           $('body').removeClass('videoScrolled');
 //                         //$('.MainWorkGrid_Section').css("display", "block");
 //                            if ($('.Our_WorkPage[data-attr="all"]').hasClass("all_active")) {        
 //        }else{          
 //         $('.Our_WorkPage[data-attr="all"]').addClass('all_active');
 //           $('.Our_WorkPage[data-attr="all"]').trigger('click');
 //        }
 //            $(document).off('touchmove');
 //                            },500);
 //          });
         

 //        }else
 // {
 //    setTimeout(function() {
 //    $('body').addClass('videoScrolled');
 //      //$('.MainWorkGrid_Section').css("display", "none");
 //       },0.5);
 // }

      

  

 //    });
slick_2.on("wheel", function(e) {
    slick_handle_wheel_event_debounced(e.originalEvent, slick_2, slick_2_is_animating);
});


$(document).on('click','.slick-dots li button',function(){
  setTimeout(function() {
if ($('.Our_WorkPage[data-attr="all"]').hasClass("all_active")) {
        
        }else{
           
          $('.Our_WorkPage[data-attr="all"]').addClass('all_active');
           $('.Our_WorkPage[data-attr="all"]').trigger('click');
        }
  },100);
});


// CLASS ACTIVE ON THE SCROLL ON THE HEADER. 
  $(document).ready(function(){
      var scrollPos = 0;
      var Counter = 0;
      $(window).scroll(function(){
          var scrollPosCur = $(this).scrollTop();
          if (scrollPosCur >= 800) {
              Counter -= 1;
            $('.New_BeaconHeader').addClass('BeaconHeaderactive');
            $('.WorkMAin').addClass("WorkActive");
            $('.BlockMain').addClass('New_BlockMain');
            
          }
            
          else {
              Counter += 1;
             $('.New_BeaconHeader').removeClass('BeaconHeaderactive');
             $('.WorkMAin').removeClass("WorkActive");
             $('.BlockMain').removeClass('New_BlockMain');
                                          
          }
          scrollPos = scrollPosCur;
      });
  });
// END CLASS ACTIVE ON THE SCROLL ON THE HEADER. 

  $(document).ready(function(){
      var scrollPos = 0;
      var Counter = 0;
      $(window).scroll(function(){
          var scrollPosCur = $(this).scrollTop();
          if (scrollPosCur >= 220) {
              Counter -= 1;
            $('.New_BeaconHeader').addClass('NEWBeaconHeaderactive');
            $('.WorkMAin').addClass("NewWorkActive");
            $('.BlockMain').addClass('MoblieNew_BlockMain');
          
            // $('.OWPMAin').addClass('New_OWPMAin');
    
          }
            
          else {
              Counter += 1;
             $('.New_BeaconHeader').removeClass('NEWBeaconHeaderactive');
             $('.WorkMAin').removeClass("NewWorkActive");
             $('.BlockMain').removeClass('MoblieNew_BlockMain');
            
            
             // $('.OWPMAin').removeClass('New_OWPMAin');            
          }
          scrollPos = scrollPosCur;
        
      });
  });

var lastScrollTop = 0;
document.addEventListener('scroll', (evt)=>{
  if ($(window).width() < 768) {
  var st = window.pageYOffset || document.documentElement.scrollTop;
   if (st > lastScrollTop) {
      console.log('downscroll code');
   } else if (st < lastScrollTop) {
      console.log('upscroll code')
   } 
   lastScrollTop = st <= 0 ? 0 : st;
  console.log("lastside"+lastScrollTop);
   if ( lastScrollTop === 0 ){
    if (window.matchMedia("(max-width: 767px)").matches) {
      setTimeout(function() {
      $('body').addClass('videoScrolled');
       
        $(".BeaconImageSubmain").slick("setPosition");
      }, 1000);
      
  

    }else{
           setTimeout(function() {
       $('body').addClass('videoScrolled');
           }, 500);
    }     
   }
  }
}, false);


$(document).on('click', '.workgridlist .HOME', function(){
$('body').addClass('videoScrolled');
    
});
   